<absg-spinner id="homeSpinner" class="spinner-cover-all" [show]="isSpinnerVisible" [isPageSpinner]="true"></absg-spinner>
<div class="nim__wrapper">
  <div id="e2eFormWrapper" hidden style="width: 100%">
    <form>
      <input type="text" id="e2eTestDescription" style="width: 15%; font-size: 8pt;"><input type="text" id="e2eTestName"
        style="width: 35%; font-size: 8pt"><input type="text" id="e2eTestStep" style="width: 50%; font-size: 8pt">
    </form>
  </div>
  <button id="extendSuccessAlertTimeout" hidden (click)="extendSuccessAlertTimeout()"> Extend Success Alert Timeout</button>
  <button id="btnSwitchStation" hidden (click)="onBtnSwitchStation()">Show Switch Station Dialog</button>
  <button id="btnBarcodeScan" hidden (click)="onBtnBarcodeScan()">Show Barcode Scanner Simulator Dialog</button>
  <button id="enableBarcodeScan" hidden (click)="enableBarcodeScan()">Enable Barcode Scan</button>
  <div nc-e2e-print-info></div>
  @if (!fullScreen) {
    <header class="header">
      <div nc-authentication></div>
    </header>
    <absg-alert-banner-summary id="alertBannerSummary"></absg-alert-banner-summary>
  }
  @if (!fullScreen || (showWarningMsg$ | async)) {
    <absg-alert-summary id="confirmModalSummary"></absg-alert-summary>
  }
  <div nc-resolve-failed-door></div>
  <absg-station-idle-warning id="idleWarning"></absg-station-idle-warning>
  <absg-station-token-expiration-warning id="tokenExpirationWarning"></absg-station-token-expiration-warning>
  <router-outlet></router-outlet>
  @if (showAccessDenied) {
    <div id="accessDeniedModal" nc-access-denied (isAccessDeniedOkClicked)="isAccessDeniedOkClicked()"></div>
  }
</div>
@if (isScannerOn) {
  <div nh-scanner-detector (scan)="scanDetected($event)"></div>
}
<div nc-switch-station [isModalOpen$]="switchStationOpenAction$" (onClose)="onSwitchStationClose()"></div>
<absg-barcode-simulator [isStation]="true" [isModalOpen]="(barcodeSimulatorOpenAction$ | async)" [practiceId]="practiceIdForBarcodeSimulator"
  (closeModal)="onBarcodeSimulatorClose()"></absg-barcode-simulator>
<div nc-door-access-modal [hotKeyTriggered]="(openAccessDoorModal$ | async)" (closeModal)="resetAccessDoorModal()"></div>
<div nc-print-notes-dev [hotKeyTriggered]="(devPrintOpenAction$ | async)" (onClose)="onDevPrintClose()"></div>